/**
 * SectionCard — the card wrapper used by every section on the CAP detail page.
 * Modernized: rounded-2xl, subtle layered shadow, tighter heading scale, more
 * generous interior spacing.
 */

import React from 'react';

export default function SectionCard({ title, hint, children, accent }) {
  return (
    <section
      className={
        'bg-white rounded-2xl ring-1 ring-slate-200/80 shadow-[0_1px_2px_rgba(15,23,42,0.04)] ' +
        'p-6 sm:p-7 transition'
      }
    >
      <header className="mb-5 flex items-start justify-between gap-3">
        <div>
          <h2 className="text-[16px] font-semibold text-slate-900 tracking-tight">{title}</h2>
          {hint && (
            <p className="text-[13px] text-slate-500 mt-1 leading-relaxed">{hint}</p>
          )}
        </div>
        {accent && <div className="shrink-0">{accent}</div>}
      </header>
      {children}
    </section>
  );
}
